import React from "react";

export default (props) => (
  <button
    className={
      "btn btn-modalidades" + (props.selected ? " selected" : "")
    }
    onClick={props.onClick}
  >
    {props.value}
  </button>
);



// WEBPACK FOOTER //
// ./src/loteria/loteriaButton.jsx